module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "Alpha.2ab62991.svg";